import { NumberInput } from 'govwell-ui'

import { NumberFormat } from 'src/utils/number'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  field: TanstackField<number | null | undefined, TKey>
  format?: NumberFormat
  isRequired?: boolean
  label?: React.ReactNode
  placeholder?: string
  width?: React.CSSProperties['width']
}
const NumberField = <TKey extends string>({
  caption,
  field,
  format,
  isRequired,
  label,
  placeholder,
  width,
}: Props<TKey>) => {
  return (
    <NumberInput
      caption={caption}
      format={format}
      label={label}
      isRequired={isRequired}
      onValueChange={field.setValue}
      placeholder={placeholder}
      value={field.state.value}
      width={width}
    />
  )
}

export default NumberField
